import { FC } from 'react';

import { useAddPartnerModal } from './context/AddPartnerModalContext';
import AddPartnerModalHeader from './components/AddPartnerModalHeader';
import AddPartnerModalBody from './components/AddPartnerModalBody';
import AddPartnerModalFooter from './components/AddPartnerModalFooter';
import CustomLoading from '../../CustomLoading';

import '../Modals.scss';

const AddPartnerModal: FC = () => {
  const { data } = useAddPartnerModal();

  return (
    <>
      <AddPartnerModalHeader />
      <AddPartnerModalBody />
      <AddPartnerModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default AddPartnerModal;
